import * as Types from '@battlefly/__generated__/globalTypes';

import { gql } from '@apollo/client';
export type CoreModPackModBlueprintFieldsFragment = { __typename?: 'ModBlueprintInModPack', category: string, description: string, type: Types.ModType, id: string, rarity: Types.Rarity, name: string, isPicked: boolean, isUpgraded: boolean, appearance: { __typename?: 'ModAppearance', image: string | null }, weapon: { __typename?: 'WeaponBlueprint', reload: number, damagePerFire: number, burst: number } | null, defense: { __typename?: 'DefenseBlueprint', shield: number, armor: number, evasion: number } | null };

export type CoreModBlueprintFieldsFragment = { __typename?: 'ModBlueprint', category: string, description: string, type: Types.ModType, id: string, rarity: Types.Rarity, name: string, appearance: { __typename?: 'ModAppearance', image: string | null, model: string, location: string | null }, weapon: { __typename?: 'WeaponBlueprint', reload: number, damagePerFire: number, burst: number } | null, defense: { __typename?: 'DefenseBlueprint', shield: number, armor: number, evasion: number } | null };

export type CoreModFieldsFragment = { __typename?: 'Mod', id: string, name: string, damageType: string | null, rarity: string, type: string, effects: any, stats: any, slot: number, blueprint: { __typename?: 'ModBlueprint', category: string, description: string, type: Types.ModType, id: string, rarity: Types.Rarity, name: string, appearance: { __typename?: 'ModAppearance', image: string | null, model: string, location: string | null }, weapon: { __typename?: 'WeaponBlueprint', reload: number, damagePerFire: number, burst: number } | null, defense: { __typename?: 'DefenseBlueprint', shield: number, armor: number, evasion: number } | null } };

export type CorBattleflyFieldsFragment = { __typename?: 'BattleFly', id: string, slotsAvailable: number, stage: string, name: string, class: Types.BattleFlyClass | null, edition: string, rarity: Types.Rarity | null, location: Types.BattleFlyLocation, provingGroundsCombatRate: number, hyperdomeCombatRate: number, placeInGlobalLeaderboard: number, age: number, starsRate: number, league: Types.BattleFlyLeague, leagueTier: number, contestPoints: number, level: number | null, traits: Array<{ __typename?: 'Trait', name: string, damageType: string | null, stat: string, value: number, unitType: Types.UnitType, id: string }> | null, appearance: { __typename?: 'BattleFlyAppearance', image: string | null }, mods: Array<{ __typename?: 'Mod', id: string, name: string, damageType: string | null, rarity: string, type: string, effects: any, stats: any, slot: number, blueprint: { __typename?: 'ModBlueprint', category: string, description: string, type: Types.ModType, id: string, rarity: Types.Rarity, name: string, appearance: { __typename?: 'ModAppearance', image: string | null, model: string, location: string | null }, weapon: { __typename?: 'WeaponBlueprint', reload: number, damagePerFire: number, burst: number } | null, defense: { __typename?: 'DefenseBlueprint', shield: number, armor: number, evasion: number } | null } }>, inventory: Array<{ __typename?: 'Mod', id: string, name: string, damageType: string | null, rarity: string, type: string, effects: any, stats: any, slot: number, blueprint: { __typename?: 'ModBlueprint', category: string, description: string, type: Types.ModType, id: string, rarity: Types.Rarity, name: string, appearance: { __typename?: 'ModAppearance', image: string | null, model: string, location: string | null }, weapon: { __typename?: 'WeaponBlueprint', reload: number, damagePerFire: number, burst: number } | null, defense: { __typename?: 'DefenseBlueprint', shield: number, armor: number, evasion: number } | null } }>, owner: { __typename?: 'Identity', id: string, user: { __typename?: 'User', id: string, wallets: Array<{ __typename?: 'Wallet', address: string }> } } | null, tattoos: Array<{ __typename?: 'Tattoo', id: string, name: string, amount: number }> };

export type CoreHuntersMarkFieldsFragment = { __typename?: 'BattleFly', huntersMark: { __typename?: 'BattleFlyHuntersMark', id: string, type: Types.HuntersMarkType, createdAt: any, willExpireAt: any } | null };

export type CoreScavengingMarkFieldsFragment = { __typename?: 'BattleFly', scavengingMark: { __typename?: 'BattleFlyScavengingMark', id: string, type: Types.ScavengingMarkType, createdAt: any, willExpireAt: any } | null };

export const CoreModPackModBlueprintFieldsFragmentDoc = gql`
    fragment CoreModPackModBlueprintFields on ModBlueprintInModPack {
  appearance {
    image
  }
  category
  description
  type
  id
  rarity
  name
  isPicked
  isUpgraded
  weapon {
    reload
    damagePerFire
    burst
  }
  defense {
    shield
    armor
    evasion
  }
}
    `;
export const CoreModBlueprintFieldsFragmentDoc = gql`
    fragment CoreModBlueprintFields on ModBlueprint {
  appearance {
    image
    model
    location
  }
  category
  description
  type
  id
  rarity
  name
  weapon {
    reload
    damagePerFire
    burst
  }
  defense {
    shield
    armor
    evasion
  }
}
    `;
export const CoreModFieldsFragmentDoc = gql`
    fragment CoreModFields on Mod {
  id
  name
  damageType
  rarity
  type
  effects
  stats
  slot
  blueprint {
    ...CoreModBlueprintFields
  }
}
    ${CoreModBlueprintFieldsFragmentDoc}`;
export const CorBattleflyFieldsFragmentDoc = gql`
    fragment CorBattleflyFields on BattleFly {
  id
  slotsAvailable
  stage
  traits {
    name
    damageType
    stat
    value
    unitType
    id
  }
  name
  class
  edition
  rarity
  location
  provingGroundsCombatRate
  hyperdomeCombatRate
  placeInGlobalLeaderboard
  age
  starsRate
  league
  leagueTier
  contestPoints
  level
  appearance {
    image
  }
  class
  mods {
    ...CoreModFields
  }
  inventory {
    ...CoreModFields
  }
  owner {
    id
    user {
      id
      wallets {
        address
      }
    }
  }
  tattoos {
    id
    name
    amount
  }
}
    ${CoreModFieldsFragmentDoc}`;
export const CoreHuntersMarkFieldsFragmentDoc = gql`
    fragment CoreHuntersMarkFields on BattleFly {
  huntersMark {
    id
    type
    createdAt
    willExpireAt
  }
}
    `;
export const CoreScavengingMarkFieldsFragmentDoc = gql`
    fragment CoreScavengingMarkFields on BattleFly {
  scavengingMark {
    id
    type
    createdAt
    willExpireAt
  }
}
    `;